import { makeStyles } from "@material-ui/core";
import { color } from "../../../assets/const/color";

export const useStyles = makeStyles(() => ({
    leave: {
    "& .MuiInputBase-root": {
      borderRadius: "50px",
      fontFamily: "inter !important",
    },
    "& .MuiButton-root:hover": {
      background: `#9DB2CE !important`,
      color: `${color.white} !important`,
    },
    "& .MuiCheckbox-colorPrimary.Mui-checked": {
      color: `${color.gray} !important`,
      borderRadius: "50px !important",
    },
    "& .MuiCheckbox-root.MuiCheckbox-indeterminate": {
      color: `${color.gray} !important`,
    },
    "& .MuiTableHead-root": {
      background: "#FEB62C",
      "& .MuiTableCell-root": {
        color: `${color.white} !important`,
        fontFamily: "inter",
      },
      "& :first-child": {
        borderRadius: "10px 0px 0px 0px !important",
      },
      "& :last-child": {
        borderRadius: "0px 10px 0px 0px !important",
      },
    },
    "& .MuiTableRow-root .MuiTableCell-root": {
      fontFamily: "inter !important",
    },
  },
}));
